export default __webpack_public_path__ + "static/media/IMG_1057cropped.0b9e0db3.jpeg";